import { render, staticRenderFns } from "./AccountSelection_SDD.vue?vue&type=template&id=b448613e&"
import script from "./AccountSelection_SDD.vue?vue&type=script&lang=js&"
export * from "./AccountSelection_SDD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports